export default {
  SEARCH_CATALOG_ALLIANZ_SETTLEMENT_QUERY: Symbol.for('SEARCH_CATALOG_ALLIANZ_SETTLEMENT_QUERY'),
  CATALOG_ALLIANZ_SETTLEMENT_REPOSITORY: Symbol.for('CATALOG_ALLIANZ_SETTLEMENT_REPOSITORY'),
  CATALOG_ALLIANZ_SETTLEMENT_STATE_MANAGER: Symbol.for('CATALOG_ALLIANZ_SETTLEMENT_STATE_MANAGER'),
};
